import RestrictedAccess from './RestrictedAccess'

const ViewerAccess = ({ children }) => {
    return (
        <RestrictedAccess
            allowedRoles={['Editor', 'Viewer']}
        >
            {children}
        </RestrictedAccess>
    )
}

export default ViewerAccess